module.exports = require("@mui/icons-material/PauseCircle");